<template>
  <div>
    <x-grid
        ref="grid"
        :id="'formList'"
        :rowId="rowId"
        :url="url"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :columns="columns"
        :otherParams="{'custId':custId}"
        :checkbox-config="checkboxConfig"
        :cellClick="chooseRow"
        :height="680"
    >
    </x-grid>


    <div class="footer_func">
      <a-button class="submit r" @click="chooseOneRows" type="primary">确定</a-button>
      <a-button class="r" @click="closePop">取消</a-button>
    </div>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'

console.info(fmt)

const fac = XGrid.factory;

//列表接口
const url = api.client.CUSTOMER + '/getCustList';

//主键
const rowId = 'custId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("custName", "客户名称", 140),
  fac.makeColumn("mobile", "手机号", 140, "center"),
  fac.makeColumn("companyName", "公司名称", 160, "center"),
  fac.makeColumn("userName", "跟进人", 160, "center"),
]

//筛选项
const list = [
  {field: 'custName'},
  {field: 'mobile'},
  {field: 'companyName'},
  {field: 'userName'}
]
const formConfig = fac.makeFormConfig(columns, list)

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  addData: false,
  delData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig(10);
const checkboxConfig = fac.makeCheckboxConfig(columns);

export default {
  mixins: [GridMixin],
  components: {},
  props: ['custId'],
  data() {
    return {
      columns,
      rowId,
      url,
      list,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  mounted() {
  },
  methods: {
    async chooseOneRows() {
      let rows = this.getRows();
      if (rows.length === 1) {
        const row = rows[0]
        this.$emit('choose', row);
      } else {
        this.$message.error('请选择一条数据')
      }
    },
    /**
     * 关闭弹出层
     */
    closePop() {
      this.$emit('closePop', this.type);
    },


  }
}
</script>

<style scoped>
.submit {
  /*border-color: #0158ff !important;*/
  /*background-color: #0158ff !important;*/
  /*color: #ffffff;*/
  margin-left: 10px;
}
</style>


